module.exports = __webpack_public_path__ + "assets/img/鲜美意.5cee1c72.png";